import { ModalName } from '@/constants/modals';

import type { RejectionSuccessPayload } from '@/components/modal/Profile/rejectProfile/types';

import { useModalStore } from '@/dsComponents/modals/modalStore';

export const openProfileRejectionModal = (
	workersIds: string[],
	companyNeedId: string,
	includeCompanyNeedRejection: boolean = false,
	onSuccess: (
		payload: RejectionSuccessPayload
	) => void | Promise<void> = () => {},
	isMissionProposed: boolean = false,
	fromJobOffer: boolean = false,
	workerName?: string,
	onRemoveFromAgency: (workerIds: string[]) => void | Promise<void> = () => {},
	canSetNonDelegable?: boolean
) => {
	const modalStore = useModalStore();

	modalStore.actions.open(ModalName.RejectProfileWorkerModal, {
		open: true,
		workersIds,
		workerName,
		companyNeedId,
		includeCompanyNeedRejection,
		isMissionProposed,
		fromJobOffer,
		canSetNonDelegable,
		onSuccess,
		onRemoveFromAgency,
	});
};
